import React, { useEffect } from "react";
import { Grid, Button } from "@mui/material";

const ShimmerEffect = ({ style, variant = "rectangle" }) => {
  return (
    <div
      style={{
        ...style,
        background:
          "linear-gradient(90deg, #e0e0e0 25%, #f8f8f8 50%, #e0e0e0 75%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite",
        borderRadius: variant === "circle" ? "50%" : "6px",
      }}
    />
  );
};

const StepperShimmer = () => {
  useEffect(() => {
    if (!document.getElementById("shimmer-style")) {
      const shimmerAnimation = `
        @keyframes shimmer {
          from {
            background-position: 200% 0;
          }
          to {
            background-position: -200% 0;
          }
        }
      `;
      const style = document.createElement("style");
      style.type = "text/css";
      style.id = "shimmer-style";
      style.innerHTML = shimmerAnimation;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <div style={{ padding: "40px", background: "#e8f0fc", minHeight: "100vh" }}>
      <div
        style={{
          margin: "0 auto",
          background: "#fff",
          padding: "40px",
          borderRadius: 12,
        }}
      >
        {/* Stepper */}
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
          style={{ marginBottom: 30 }}
        >
          {[1, 2, 3, 4].map((step, idx) => (
            <Grid item key={idx} xs={3}>
              <div style={{ textAlign: "center" }}>
                <ShimmerEffect
                  style={{
                    width: 30,
                    height: 30,
                    margin: "0 auto 8px",
                    borderRadius: "50%",
                  }}
                />
                <ShimmerEffect
                  style={{ width: "60%", height: 12, margin: "0 auto" }}
                />
              </div>
            </Grid>
          ))}
        </Grid>

        {/* Body */}
        <Grid container spacing={2}>
          {/* Text section */}
          <Grid item xs={12} md={7}>
            <ShimmerEffect
              style={{ width: "90%", height: 20, marginBottom: 16 }}
            />
            <ShimmerEffect
              style={{ width: "100%", height: 15, marginBottom: 12 }}
            />
            <ShimmerEffect
              style={{ width: "100%", height: 15, marginBottom: 12 }}
            />
            <ShimmerEffect
              style={{ width: "95%", height: 15, marginBottom: 12 }}
            />
            <ShimmerEffect
              style={{ width: "85%", height: 15, marginBottom: 12 }}
            />
            <ShimmerEffect
              style={{ width: "75%", height: 15, marginBottom: 12 }}
            />
          </Grid>

          {/* Video/Image placeholder */}
          <Grid item xs={12} md={5}>
            <div
              style={{
                position: "relative",
                width: "100%",
                paddingTop: "56.25%",
              }}
            >
              <ShimmerEffect
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          </Grid>
        </Grid>

        {/* Button shimmer */}
        <div style={{ marginTop: 40, textAlign: "left" }}>
          <ShimmerEffect style={{ width: 140, height: 40, borderRadius: 6 }} />
        </div>
      </div>
    </div>
  );
};

export default StepperShimmer;
